export default {
  data() {
    return {
      showing: false,
    };
  },
  methods: {
    modelShow() {
      this.showing = true;
    },
    modelHide() {
      this.showing = false;
    },
    modelToggle() {
      this.showing = !this.showing;
    },
  },
};
